export default __webpack_public_path__ + "static/media/proofy.2970975b.svg";